import { useMemo } from "react";
function useStyles(props) {
  const { gradientWidth, showMoreColor } = props;
  return useMemo(() => {
    return {
      root: {
        "--gradient-width": `${gradientWidth}px`,
        "--show-more-color": showMoreColor
      }
    };
  }, [showMoreColor, gradientWidth]);
}
export {
  useStyles
};
//# sourceMappingURL=useStyles.js.map
